import styled from 'styled-components';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';

export const StyledTitleText = styled(Text)`
  text-align: center;
  max-width: 648px;
  margin: auto;
  margin-bottom: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    max-width: 333px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 890px;
  }
`;
export const StyledBodyText = styled(Text)`
  text-align: center;
  max-width: 445px;
  margin: auto;
  ${themeMediaQuery('below_sm')} {
    max-width: 322px;
  }
  ${themeMediaQuery('xl')} {
    max-width: 524px;
  }
`;
